export function getApiUrl(): string {
  return import.meta.env.VITE_REACT_APP_API_URI ?? '';
}

export function getOAuthUrl(): string {
  return import.meta.env.VITE_REACT_APP_OAUTH_URL ?? '';
}
